
import { FormField, FormItem, FormControl, FormLabel, FormDescription, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { ApplicationFormValues } from "./formSchema";

interface AcceptanceSectionProps {
  form: UseFormReturn<ApplicationFormValues>;
}

export function AcceptanceSection({ form }: AcceptanceSectionProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">4. Acceptation</h3>
      
      <FormField
        control={form.control}
        name="acceptedContact"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                J'accepte d'être recontacté.e pour prendre part au challenge
              </FormLabel>
              <FormDescription>
                Nous pourrons vous contacter par email ou téléphone.
              </FormDescription>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
